import * as React from "react";
import PropTypes from 'prop-types';

const SvgInformation = props => {
  if (props.id !== "_svginformation") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h48v48H0z" /><path d="M25 10.8c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zm.75 19.067a.75.75 0 01-1.5 0V19.683a.75.75 0 011.5 0v10.184zM25 17.95A.975.975 0 1125 16a.975.975 0 010 1.95z" fill="#056B9E" /></g></svg>;
};

SvgInformation.displayName = "_svginformation";
SvgInformation.propTypes = {
  id: PropTypes.string
};
SvgInformation.defaultProps = {
  id: ''
};
export default SvgInformation;